import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SkeletonTableRowsComponent } from '@suvo/frontend/standalone/table/table-skeleton-rows.component';
import { SuvoCoreClientLibModule } from '@suvo/frontend/SUVO-CORE-CLIENT-LIB/projects/suvo-core-client-lib/src/lib/suvo-core-client-lib.module';
import { FiltersModule } from '@suvo/frontend/SUVO-BI-CLIENT-LIB/projects/suvo-bi-client-lib/src/lib/features/filters/filters.module';
import { TablesModule } from '@suvo/frontend/SUVO-BI-CLIENT-LIB/projects/suvo-bi-client-lib/src/lib/features/tables/tables.module';
import { ReferencesModule } from '@suvo/frontend/SUVO-BI-CLIENT-LIB/projects/suvo-bi-client-lib/src/lib/features/references/references.module';
import { HeaderComponent } from '../../../shared/components/header/header.component';
import { SharedModule } from '../../../shared/shared.module';
import { CheckBlockModule } from '../check-block/check-block.module';
import { MeasurementFormComponent } from '../measurement/components/measurement-form.component';
import { MeasurementListItemComponent } from '../measurement/components/measurement-list-item.component';
import { MeasurementModule } from '../measurement/measurement.module';
import { PermissionsModule } from '../permissions/permissions.module';
import { PrintoutMenu } from '../printouts/components/printout-menu.component';
import { TaxonModule } from '../taxon/taxon.module';
import { AbundanceCategoriesComponent } from '../taxon-abundance-category/components/abundance-categories.component';
import { TowLogMapComponent } from '../tow-log/components/map/tow-log-map.component';
import { UsersModule } from '../users/users.module';
import { MyActiveSamplesComponent } from './components/my-active-samples/my-active-samples.component';
import { PciColourComponent } from './components/pci-colour/pci-colour.component';
import { SampleStatus } from './components/sample-status/sample-status.component';
import { SamplesTableComponent } from './components/table/samples-table.component';
import { AnalysisOverviewClickableCellComponent } from './screens/sample-analysis-overview/components/clickable-cell.component';
import { SampleAnalysisGrid } from './screens/sample-analysis-overview/components/sample-analysis-grid.component';
import { SampleDataEntryScreenComponent } from './screens/sample-data-entry/sample-data-entry-screen.component';
import { SamplesListScreenComponent } from './screens/samples-list-screen/samples-list-screen.component';
import { DataEntryCheckBlockPanelComponent } from './screens/sample-data-entry/components/check-block-panel.component';
import { DataEntrySampleSwitcherComponent } from './screens/sample-data-entry/components/sample-switcher.component';
import { DataEntryCheckBlocksComponent } from './screens/sample-data-entry/components/sample-check-blocks.component';
import { SampleDetailsFormComponent } from './screens/sample-data-entry/components/sample-details-form.component';
import { SamplesService } from './service/samples.service';

@NgModule({
  imports: [
    // Angular
    CommonModule,

    // Shared
    SharedModule,

    // SUVO lib
    FiltersModule,
    TablesModule,
    ReferencesModule,
    SuvoCoreClientLibModule,

    // Project features
    CheckBlockModule,
    MeasurementModule,
    PermissionsModule,
    TaxonModule,
    UsersModule,

    // Standalone Components
    HeaderComponent,
    MeasurementListItemComponent,
    DataEntryCheckBlocksComponent,
    DataEntryCheckBlockPanelComponent,
    AnalysisOverviewClickableCellComponent,
    TowLogMapComponent,
    AbundanceCategoriesComponent,
    SampleDetailsFormComponent,
    PrintoutMenu,
    SampleAnalysisGrid,
    MeasurementFormComponent,
    SampleStatus,
    SkeletonTableRowsComponent,
  ],
  declarations: [
    // Components
    SamplesTableComponent,
    PciColourComponent,

    // Data entry screen components
    DataEntrySampleSwitcherComponent,

    // Screens
    SampleDataEntryScreenComponent,
    SamplesListScreenComponent,
    MyActiveSamplesComponent,
  ],
  providers: [SamplesService],
  exports: [PciColourComponent, MyActiveSamplesComponent],
})
export class SamplesModule {}
